<template>
  <div class="flex">
    <vue-sharelinks
      :url="url"
      :platforms="shareLinksPlatforms"
    >
      <template v-slot:facebook v-if="facebook">
        <svg-sprite href="icon-facebook" class="inline-block h-7.5 w-7.5 text-blue-brand hover:text-blue-dark mr-5"></svg-sprite>
      </template>
      <template v-slot:twitter v-if="twitter">
        <svg-sprite href="icon-twitter" class="inline-block h-7.5 w-7.5 text-blue-brand hover:text-blue-dark mr-5"></svg-sprite>
      </template>
      <template v-slot:linkedin v-if="linkedin">
        <svg-sprite href="icon-twitter" class="inline-block h-7.5 w-7.5 text-blue-brand hover:text-blue-dark mr-5"></svg-sprite>
        <svg class="inline-block h-7.5 w-7.5 text-blue-brand hover:text-blue-dark mr-5" style="
    " xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="100" height="100">
            <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.08 108.1 0 83.49 0 54.08 0 24.08 24.08 0 53.79 0s53.8 24.08 53.8 54.08c.01 29.41-24.07 54.02-53.8 54.02zM447.9 448h-92.68V302.4c0-34.7-12.44-58.4-43.57-58.4-23.77 0-37.92 15.96-44.17 31.38-2.27 5.47-2.84 13.1-2.84 20.78V448h-92.75s1.23-269.5 0-297.6h92.74v42.15c-.18.29-.43.57-.61.86h.61v-.86c12.32-18.98 34.31-46.08 83.41-46.08 60.92 0 106.56 39.76 106.56 125.17V448z" fill="currentColor"/>
          </svg>
      </template>
    </vue-sharelinks>
    <a v-if="email" :href="`mailto:?subject=YellowWood Adventures - ${title}&body=${url}`" target="_blank" rel="noopener noreferrer" class="inline-block">
      <svg-sprite href="icon-mail" class="h-7.5 w-7.5 text-blue-brand hover:text-blue-dark mr-5"></svg-sprite>
    </a>
    <a v-if="copyUrl" href="#" class="js-copy-to-clipboard inline-block" :data-link="url" @click.prevent="doCopy">
      <svg-sprite href="icon-link" class="h-7.5 w-7.5 text-blue-brand hover:text-blue-dark"></svg-sprite>
    </a>
    <div v-if="copied" class="pl-4 text-sm flex items-center">URL copied!</div>
  </div>
</template>

<script>
import SvgSprite from '../vendor/enso/components/SvgSprite.vue';
import VueSharelinks from 'vue-sharelinks';

export default {
  components: {
    SvgSprite,
    VueSharelinks,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: window.location.href,
    },
    twitter: {
      type: Boolean,
      default: false,
    },
    facebook: {
      type: Boolean,
      default: true,
    },
    linkedin: {
      type: Boolean,
      default: true,
    },
    email: {
      type: Boolean,
      default: true,
    },
    copyUrl: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      copied: false,
    };
  },

  computed: {
    shareLinksPlatforms() {
      const platforms = [];

      if (this.twitter) {
        platforms.push('twitter');
      }

      if (this.linkedin) {
        platforms.push('linkedin');
      }

      if (this.facebook) {
        platforms.push('facebook');
      }

      return platforms;
    },
  },

  methods: {
    doCopy() {
      // https://stackoverflow.com/questions/49149387/copy-data-attribute-to-clipboard-on-click-with-purejs
      let textArea = document.createElement('textarea');
      textArea.value = this.url;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
      } catch (err) {
        console.log('Oops, unable to copy');
      }
      document.body.removeChild(textArea);

      this.copied = true;
    },
  }
};
</script>
